<template>
  <div class="not-found">
    <div class="container py-5">
      <div class="text-center">
        <h1 class="display-1">404</h1>
        <h2 class="mb-4">Page Not Found</h2>
        <p class="mb-4">The page you are looking for does not exist.</p>
        <router-link to="/" class="btn btn-primary">Go Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>
